import { render, staticRenderFns } from "./SimpleTimetable.vue?vue&type=template&id=05557402&"
import script from "./SimpleTimetable.vue?vue&type=script&lang=js&"
export * from "./SimpleTimetable.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTimetable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports